<template>
    <van-popup v-model="show" position="bottom" round>
        <div class="time-picker-header">
            <div class="time-picker-cancel" @click="handleCancel">取消</div>
            <div class="time-picker-title">{{ title }}</div>
            <div class="time-picker-confirm" @click="handleConfirm">确定</div>
        </div>
        <van-picker :columns="columns" @change="onChange" ref="picker" />
    </van-popup>
</template>

<script>
export default {
    name: "TimePicker",
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "选择时间",
        },
        // 默认时间值，格式：HH:mm:ss 或 HH:mm
        defaultTime: {
            type: String,
            default: "00:00:00",
        },
    },
    data() {
        // 初始化 columns，使用字符串数组格式（更兼容 Vant 2.x）
        const hours = {
            values: [],
            defaultIndex: 1,
        };
        for (let i = 0; i < 24; i++) {
            hours.values.push(String(i).padStart(2, "0") + "时");
        }
        const minutes = {
            values: [],
            defaultIndex: 1,
        };
        for (let i = 0; i < 60; i++) {
            minutes.values.push(String(i).padStart(2, "0") + "分");
        }
        const seconds = {
            values: [],
            defaultIndex: 1,
        };
        for (let i = 0; i < 60; i++) {
            seconds.values.push(String(i).padStart(2, "0") + "秒");
        }

        return {
            show: false,
            selectedTime: {
                hour: 0,
                minute: 0,
                second: 0,
            },
            columns: [hours, minutes, seconds],
            defaultIndex: [0, 0, 0],
        };
    },
    watch: {
        value(newVal) {
            this.show = newVal;
            if (newVal) {
                this.initTime();
                // 等待 DOM 更新后设置选择器位置
                this.$nextTick(() => {
                    this.setPickerIndexes();
                });
            }
        },
        show(newVal) {
            this.$emit("input", newVal);
            if (newVal) {
                this.$nextTick(() => {
                    this.setPickerIndexes();
                });
            }
        },
        defaultTime() {
            if (this.show) {
                this.initTime();
                this.$nextTick(() => {
                    this.setPickerIndexes();
                });
            }
        },
    },
    created() {
        console.log("columns", this.columns);
        this.initTime();
    },
    methods: {
        // 设置选择器索引
        setPickerIndexes() {
            if (this.$refs.picker) {
                try {
                    // Vant 2.x 使用 setIndexes 方法
                    if (typeof this.$refs.picker.setIndexes === "function") {
                        this.$refs.picker.setIndexes(this.defaultIndex);
                    } else if (
                        typeof this.$refs.picker.setColumnIndex === "function"
                    ) {
                        // 如果支持单独设置每列
                        this.$refs.picker.setColumnIndex(
                            0,
                            this.defaultIndex[0]
                        );
                        this.$refs.picker.setColumnIndex(
                            1,
                            this.defaultIndex[1]
                        );
                        this.$refs.picker.setColumnIndex(
                            2,
                            this.defaultIndex[2]
                        );
                    }
                } catch (e) {
                    console.warn("设置选择器索引失败:", e);
                }
            }
        },
        // 初始化时间
        initTime() {
            let hour = 0,
                minute = 0,
                second = 0;

            if (this.defaultTime) {
                const timeParts = this.defaultTime.split(":");
                if (timeParts.length >= 1) {
                    hour = parseInt(timeParts[0]) || 0;
                }
                if (timeParts.length >= 2) {
                    minute = parseInt(timeParts[1]) || 0;
                }
                if (timeParts.length >= 3) {
                    second = parseInt(timeParts[2]) || 0;
                }
            }

            this.selectedTime = {
                hour: hour,
                minute: minute,
                second: second,
            };

            this.defaultIndex = [hour, minute, second];
        },
        // 选择器变化
        onChange(picker, values, indexes) {
            console.log(values);
            if (values && values.length >= 3) {

                const hourStr =
                    typeof values[0] === "string"
                        ? values[0]
                        : String(values[0]);
                const minuteStr =
                    typeof values[1] === "string"
                        ? values[1]
                        : String(values[1]);
                const secondStr =
                    typeof values[2] === "string"
                        ? values[2]
                        : String(values[2]);

                // 从字符串中提取数字（例如 "01时" -> 1）
                const hour = parseInt(hourStr.replace(/[^0-9]/g, "")) || 0;
                const minute = parseInt(minuteStr.replace(/[^0-9]/g, "")) || 0;
                const second = parseInt(secondStr.replace(/[^0-9]/g, "")) || 0;
                this.selectedTime = {
                    hour: hour,
                    minute: minute,
                    second: second,
                };
            }
        },
        // 确认
        handleConfirm() {
            const timeStr = `${String(this.selectedTime.hour).padStart(
                2,
                "0"
            )}:${String(this.selectedTime.minute).padStart(2, "0")}:${String(
                this.selectedTime.second
            ).padStart(2, "0")}`;
            this.$emit("confirm", timeStr);
            this.show = false;
        },
        // 取消
        handleCancel() {
            this.$emit("cancel");
            this.show = false;
        },
    },
};
</script>

<style scoped lang="less">
.time-picker-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--base-px-16) var(--base-px-20);
    border-bottom: 1px solid #ebedf0;
    font-size: var(--base-px-16);

    .time-picker-cancel {
        color: #969799;
        cursor: pointer;
    }

    .time-picker-title {
        font-weight: bold;
        color: #323233;
    }

    .time-picker-confirm {
        color: #1989fa;
        cursor: pointer;
    }
}
</style>
